import React from "react";

const Loading = () => {
  return (
    <section className="flex flex-col items-center justify-center gap-6 w-full h-screen bg-dry">
      <img
        src="/saigonstar/logo.webp"
        alt="404"
        className="w-full max-h-24 lg:max-h-32 object-contain m-2 "
      />
      <span className="loader block w-3 h-3 rounded-full relative animate-flash" />
    </section>
  );
};

export default Loading;
